import useSWR from "swr";
import apiClient from "../../../apiClient";
import { ITempControllSetting, TempSetting } from "../../../globals/interfaces";
import { getTsDate } from "../../../utils";
import { useState } from "react";
import _ from "lodash";

export type UpdateTempSetting = (setting: TempSetting) => Promise<void>;

const fetcher = async (endpoint: string): Promise<Array<ITempControllSetting>> => {
    try {
        const res = await apiClient.get(endpoint);
        return res.data;
    } catch (err) {
        return [];
    }
}

export default function useData (unit: string, email: string) {
    const {
        data,
        mutate
    } = useSWR(`/tempControl/data/${unit}`, fetcher, {
        refreshInterval: 300000
    });

    const [selectedItem, setSelectedItem] = useState<ITempControllSetting>();

    const updateTempSetting: UpdateTempSetting = async (setting: TempSetting) => {
        if (!selectedItem) return;

        try {
            const res = await apiClient.put(`/tempControl`, {
                unit, 
                location: selectedItem.location, 
                setting, 
                modifiedBy: email, 
                modifiedAt: getTsDate()
            });
    
            const itemCopy = _.cloneDeep(selectedItem);
            itemCopy.setting = setting;
            itemCopy.modifiedBy = email;
            itemCopy.modifiedAt = String(getTsDate());
            setSelectedItem(itemCopy);
    
            const dataCopy = _.cloneDeep(data);
            const updatedIndex = dataCopy?.findIndex(item => item.location === selectedItem.location);

            if (dataCopy && updatedIndex !== undefined) {
                dataCopy[updatedIndex] = itemCopy;
                mutate(dataCopy);
            }
        } catch (err) {
            alert(err);
        }
    }

    return {
        data,
        selectedItem, 
        setSelectedItem,
        updateTempSetting
    }
}